import * as React from 'react'
import {useEffect} from 'react'
import {observer} from 'mobx-react'
import ReCAPTCHA from 'react-google-recaptcha'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const RecaptchaBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {recaptchaKey} = api.computedConfig
  const {ref} = api.recaptcha
  let {callback} = api.recaptcha

  useEffect(() => {
    const cont = ref.current

    return () => cont?.reset()
  }, [])

  if (!recaptchaKey || !ref || !callback) {
    return null
  }

  callback = callback.bind(api)

  return (
    <div className="tamaro-recaptcha">
      <ReCAPTCHA
        ref={ref}
        onChange={callback}
        sitekey={recaptchaKey}
        size="invisible"
      />
    </div>
  )
})
